export const recipesEn = {
  recipes: {
    nav: {
      title: 'Recipes',
    },
    categories: {
      breakfast: 'Breakfast',
      lunch: 'Lunch',
      dinner: 'Dinner',
      dessert: 'Dessert',
    },
    list: {
      title: 'Family recipes',
      subtitle: 'Shared recipes for your family',
      create: 'New recipe',
      empty: 'No recipes yet. Add your first one.',
      emptyTitle: 'No recipes yet',
      noMatches: 'No recipes match your filters.',
      searchPlaceholder: 'Search recipes…',
      allCategories: 'All categories',
      servings: '{n} servings',
      open: 'Open',
      delete: 'Delete',
      deleteConfirm: 'Delete this recipe?',
    },
    detail: {
      title: 'Recipe',
      back: 'Back to recipes',
      edit: 'Edit',
      sourceLink: 'Full recipe',
      ingredients: 'Ingredients',
      addToList: 'Add to shopping list',
      addMissing: 'Add missing only',
      selectList: 'Choose a list',
      addToListSuccess: 'Added {added} items ({skipped} skipped)',
      noLists: 'Create a shopping list first',
      delete: 'Delete recipe',
    },
    edit: {
      title: 'Edit recipe',
      newTitle: 'New recipe',
      back: 'Back',
      save: 'Save',
      saving: 'Saving…',
      titleLabel: 'Title',
      titlePlaceholder: 'Recipe name',
      categoryLabel: 'Category',
      servingsLabel: 'Servings',
      sourceUrlLabel: 'Source URL',
      sourceUrlPlaceholder: 'https://…',
      ingredientsLabel: 'Ingredients',
      ingredientName: 'Ingredient',
      ingredientQty: 'Qty',
      ingredientUnit: 'Unit',
      addIngredient: 'Add ingredient',
      tagsLabel: 'Tags',
      newTagPlaceholder: 'New tag',
      addTag: 'Add tag',
      imageLabel: 'Photo',
      uploadImage: 'Upload photo',
      removeImage: 'Remove photo',
    },
    toasts: {
      created: 'Recipe created',
      saved: 'Recipe saved',
      deleted: 'Recipe deleted',
      error: 'Something went wrong with the recipe',
      imageUploaded: 'Photo uploaded',
    },
    import: {
      title: 'Import from link',
      description: 'Paste a recipe page URL — AI will fill the form for you to confirm.',
      urlLabel: 'Page URL',
      urlPlaceholder: 'https://…',
      button: 'Import',
      importing: 'Importing…',
      success: 'Recipe imported — review and save',
      error: 'Could not import recipe',
      premiumRequired: 'AI import requires Premium or your own OpenRouter API key',
    },
  },
}
